export const CHART_COLORS = Object.freeze({
  black: "#212529",
  blue: "#0d6efd",
  purple: "#6f42c1",
  orange: "#fd7e14",
});

export const CHART_PALETTE = Object.freeze(Object.values(CHART_COLORS));

export const CHART_STATUS_COLORS = Object.freeze({
  success: "#28a745",
  successDark: "#1e7e34",
  danger: "#d9534f",
  warning: "#ffc107",
  secondary: "#6c757d",
  dark: "#000000",
});

export const CHART_HEATMAP_COLORS = Object.freeze({
  empty: "#f1f3f5",
  low: "#cfe2ff",
  medium: "#6ea8fe",
  high: CHART_COLORS.blue,
});
